import { Component, OnInit } from '@angular/core';
import { AllVideosDataService } from 'src/app/core/service/AllVideosDataService';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {


  toogleNoItemFound = true;
  filteredVideos : any;
 
  updatedFilteredVideos : any = {};
  
  searchFliter : any; 

  constructor(private allvideos : AllVideosDataService) { }

  

  ngOnInit() {
    
    this.allvideos.currentFilteredVideoList.subscribe(message => {
      
      if(message.length==0){
          this.toogleNoItemFound = true;
      }else{
        this.toogleNoItemFound = false;
        //console.log(JSON.stringify(message));
        console.log("Current Video List"+message.length);
        this.filteredVideos = message;
        this.initVideosToNewFormat();
      }
      
    });
 
  }

/**
 * Convert list to new List for Filter Item
 */
  initVideosToNewFormat(){
    //"subject":"Physiology",
    ///"system":"Cardiovascular System",
    //system:subject
    this.updatedFilteredVideos = {};
    console.log("New Video Format"+this.filteredVideos.length);
    for(var i = 0; i<this.filteredVideos.length;i++){
      //console.log(this.filteredVideos[i]);
        var system_subject = this.filteredVideos[i].tags.system+" : "+this.filteredVideos[i].tags.subject;
        //console.log(""+system_subject);
        if (system_subject in this.updatedFilteredVideos) {
          //  console.log("Push again");
            this.updatedFilteredVideos[system_subject].push( this.filteredVideos[i]);
        } else {
        //  console.log("Set item for first");
          this.updatedFilteredVideos[system_subject]  = [this.filteredVideos[i]];
        }
        //this.updatedFilteredVideos[i] = this.filteredVideos[i];
    }
  //  console.log(JSON.stringify(this.updatedFilteredVideos));


  }

  getTitleName(videoItemLocal : any){
     // console.log(JSON.stringify(videoItemLocal));
      if(videoItemLocal.length < 5){
        return "Videos";
      }else{
        return videoItemLocal;
      }
      
      //return ""+JSON.stringify(videoItemLocal);
  }



}
